
import React from 'react';
import JuniorSchool from 'views/JuniorSchool';

const JuniorSchoolPage = () => {
  return <JuniorSchool />;
};

export default JuniorSchoolPage;
